// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"ColumnLayout_layoutWrapper__3yRTP","column":"ColumnLayout_column__2uTLp bodySDefault","imageColumn":"ColumnLayout_imageColumn__1a7Bb"};